"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _immutable = _interopRequireDefault(require("immutable"));

var _classnames = _interopRequireDefault(require("classnames"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _Constants = require("FileManagerCore/Constants");

var _image = require("FileManagerCore/utils/image");

var _file = require("FileManagerCore/utils/file");

var _fileSize = require("FileManagerCore/utils/fileSize");

var _VideoPlayer = require("FileManagerCore/components/VideoPlayer");

var _FileTypeIcon = _interopRequireDefault(require("FileManagerCore/components/FileTypeIcon"));

var _DeleteFileContainer = _interopRequireDefault(require("../containers/DeleteFileContainer"));

var _MoveButton = _interopRequireDefault(require("./MoveButton"));

var _EditButton = _interopRequireDefault(require("../EditButton"));

var _Filename = _interopRequireDefault(require("./Filename"));

var _ImageOptimizationControl = _interopRequireDefault(require("../controls/ImageOptimizationControl"));

var _getIsFileOptimizableImage = _interopRequireDefault(require("../../utils/getIsFileOptimizableImage"));

var _CanvaButton = _interopRequireDefault(require("FileManagerCore/components/CanvaButton"));

var _fileAccessibility = require("FileManagerCore/utils/fileAccessibility");

var _FileAccess = require("../../enums/FileAccess");

var _Files = require("FileManagerCore/api/Files");

var _FilePathBreadcrumbs = _interopRequireDefault(require("./FilePathBreadcrumbs"));

var _InsertButton = _interopRequireDefault(require("../controls/InsertButton"));

var WIDTH = 380;
var ARROW_WIDTH = 16;

var FileDetail = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FileDetail, _Component);

  function FileDetail(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FileDetail);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FileDetail).call(this, props));

    _this.trackFileUrlClick = function () {
      var tile = _this.props.tile;
      var file = tile.get('file');

      _this.props.trackInteraction('fileManagerExploreFiles', 'click-file-url-link', {
        fileType: file.get('type')
      });
    };

    _this.handleCanvaImport = _this.handleCanvaImport.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInsert = _this.handleInsert.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleMove = _this.handleMove.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRename = _this.handleRename.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateHeight = _this.updateHeight.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCloseButtonClick = _this.handleCloseButtonClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FileDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.withPanelNavigator) {
        this.startMutationObserver();
        this.updateHeight();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.props.withPanelNavigator) {
        this.stopMutationObserver();
      }
    }
  }, {
    key: "handleCanvaImport",
    value: function handleCanvaImport(_ref) {
      var canvaDesignId = _ref.canvaDesignId,
          fileUrl = _ref.fileUrl,
          originalFileId = _ref.originalFileId,
          fileName = _ref.fileName;
      var uploadedFileAccess = this.props.uploadedFileAccess;
      this.props.onAcquireFromCanva({
        canvaDesignId: canvaDesignId,
        fileUrl: fileUrl,
        originalFileId: originalFileId,
        fileName: fileName,
        uploadedFileAccess: uploadedFileAccess
      });
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      var tile = this.props.tile;
      var file = tile.get('file');

      if (!file.get('width') || !file.get('height')) {
        return null;
      }

      return file.get('width') + " x " + file.get('height') + " px";
    }
  }, {
    key: "getSize",
    value: function getSize() {
      var tile = this.props.tile;
      var file = tile.get('file');
      return (0, _fileSize.fileSize)(file.get('size'));
    }
  }, {
    key: "startMutationObserver",
    value: function startMutationObserver() {
      var wrapperNode = (0, _reactDom.findDOMNode)(this.wrapper);
      var _window = window,
          MutationObserver = _window.MutationObserver;

      if (!MutationObserver) {
        return;
      }

      this.observer = new MutationObserver(this.updateHeight);
      this.observer.observe(wrapperNode, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "stopMutationObserver",
    value: function stopMutationObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }, {
    key: "updateHeight",
    value: function updateHeight() {
      var _this$props = this.props,
          tile = _this$props.tile,
          onUpdateHeight = _this$props.onUpdateHeight;
      var file = tile.get('file');
      var wrapperNode = (0, _reactDom.findDOMNode)(this.wrapper);
      var height = wrapperNode.clientHeight;

      if (tile.get('height') !== height) {
        onUpdateHeight(file, height);
      }
    }
  }, {
    key: "handleCloseButtonClick",
    value: function handleCloseButtonClick() {
      var onClose = this.props.onClose;
      onClose({
        target: 'close-button'
      });
    }
  }, {
    key: "handleInsert",
    value: function handleInsert() {
      var _this$props2 = this.props,
          tile = _this$props2.tile,
          onClose = _this$props2.onClose,
          onInsert = _this$props2.onInsert;
      var file = tile.get('file');
      onClose({
        target: 'insert-file'
      });
      var target = 'file-detail-insert-button';

      if (this.renamePromise) {
        this.renamePromise.then(function (renamedFile) {
          return onInsert(renamedFile, {
            target: target
          });
        });
      } else {
        onInsert(file, {
          target: target
        });
      }
    }
  }, {
    key: "handleMove",
    value: function handleMove(folder) {
      var _this$props3 = this.props,
          tile = _this$props3.tile,
          onMove = _this$props3.onMove;
      var file = tile.get('file');
      onMove(file, folder);
    }
  }, {
    key: "handleRename",
    value: function handleRename(newName) {
      var _this2 = this;

      var _this$props4 = this.props,
          tile = _this$props4.tile,
          onRename = _this$props4.onRename;
      var file = tile.get('file');
      this.renamePromise = onRename(file, newName);
      this.renamePromise.finally(function () {
        _this2.renamePromise = null;
      });
    }
  }, {
    key: "renderArrow",
    value: function renderArrow(tile) {
      var arrowX = tile.get('arrowX');
      return _react.default.createElement("div", {
        className: "file-detail__arrow",
        style: {
          left: arrowX - ARROW_WIDTH * 0.5
        }
      });
    }
  }, {
    key: "renderVideoPlayer",
    value: function renderVideoPlayer(file) {
      return _react.default.createElement(_VideoPlayer.VideoPlayer, {
        className: "m-bottom-4",
        video: file,
        width: WIDTH
      });
    }
  }, {
    key: "renderImage",
    value: function renderImage(file) {
      var dimensions = {};

      if (file.get('height')) {
        dimensions = (0, _image.scaleToFit)(file, WIDTH);
      }

      return _react.default.createElement("div", {
        className: "justify-center"
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)('file-detail__image-wrapper image__transparency-checkboard m-bottom-4', {
          'square-wrapper-fix': !file.get('height')
        })
      }, (0, _image.isShutterstock)(file) && _react.default.createElement("div", {
        className: "file-detail__image-overlay"
      }), _react.default.createElement(_UIImage.default, Object.assign({
        className: "file-detail__image",
        src: (0, _file.getResizedFilePreviewUrl)(file, WIDTH),
        responsive: !file.get('height'),
        draggable: false
      }, dimensions))));
    }
  }, {
    key: "renderEditButtons",
    value: function renderEditButtons() {
      var _this$props5 = this.props,
          isCanvaFile = _this$props5.isCanvaFile,
          tile = _this$props5.tile;
      var file = tile.get('file');

      if (isCanvaFile) {
        return _react.default.createElement(_UIDropdown.default, {
          buttonClassName: "m-left-3",
          buttonSize: "xs",
          buttonText: _react.default.createElement(_FormattedMessage.default, {
            message: "FileManagerCore.actions.cloneAndEdit"
          }),
          menuWidth: "auto"
        }, _react.default.createElement(_UIList.default, null, _react.default.createElement(_EditButton.default, {
          file: file,
          openedFrom: _Constants.ImageEditorLocations.DRAWER
        }, _react.default.createElement(_FormattedMessage.default, {
          message: "FileManagerCore.actions.cropAndResize"
        }), _react.default.createElement(_Small.default, {
          className: "display-block m-all-0"
        }, _react.default.createElement(_FormattedMessage.default, {
          message: "FileManagerCore.actions.cropAndResizeDescription"
        }))), _react.default.createElement(_CanvaButton.default, {
          file: file,
          handleCanvaImport: this.handleCanvaImport
        })));
      } else {
        return _react.default.createElement(_EditButton.default, {
          openedFrom: _Constants.ImageEditorLocations.DRAWER,
          size: "extra-small",
          file: file
        });
      }
    }
  }, {
    key: "renderFile",
    value: function renderFile(file) {
      switch (file.get('type')) {
        case _Constants.FileTypes.MOVIE:
          return this.renderVideoPlayer(file);

        case _Constants.FileTypes.IMG:
          if ((0, _file.getHasThumbnail)(file)) {
            return this.renderImage(file);
          }

          return this.renderFileTypeIcon(file);

        default:
          return null;
      }
    }
  }, {
    key: "renderInsertButton",
    value: function renderInsertButton(file) {
      return _react.default.createElement(_InsertButton.default, {
        file: file,
        onInsert: this.handleInsert
      });
    }
  }, {
    key: "renderFileUrl",
    value: function renderFileUrl(file) {
      var _this$props6 = this.props,
          isHostAppContextPrivate = _this$props6.isHostAppContextPrivate,
          withPanelNavigator = _this$props6.withPanelNavigator;
      var isFilePrivate = (0, _fileAccessibility.getIsFilePrivate)(file);
      var disableFileUrlLink = (0, _fileAccessibility.getIsFilePrivate)(file) && !isHostAppContextPrivate || (0, _fileAccessibility.getIsFileExternal)(file);

      var fileUrl = _react.default.createElement(_UILink.default, {
        href: isFilePrivate ? (0, _Files.getSignedUrlRedirectViewUrl)(file.get('id')) : file.get('url'),
        external: true,
        disabled: disableFileUrlLink,
        "data-test-id": "file-detail-file-url",
        onClick: this.trackFileUrlClick
      }, _I18n.default.text('FileManagerCore.actions.openLink'));

      if (disableFileUrlLink) {
        return _react.default.createElement(_UITooltip.default, {
          title: _react.default.createElement(_FormattedMessage.default, {
            message: "FileManagerLib.privateFileExternalViewTooltip"
          })
        }, fileUrl);
      }

      if (withPanelNavigator) {
        return _react.default.createElement(_Small.default, {
          tagName: "p"
        }, fileUrl);
      }

      return fileUrl;
    }
  }, {
    key: "renderFileTypeIcon",
    value: function renderFileTypeIcon(image) {
      return _react.default.createElement(_FileTypeIcon.default, {
        size: 64,
        file: image,
        draggable: false
      });
    }
  }, {
    key: "renderImageOptimizationControl",
    value: function renderImageOptimizationControl() {
      return _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement(_ImageOptimizationControl.default, null));
    }
  }, {
    key: "renderVisibility",
    value: function renderVisibility(file) {
      var visibilityOption = (0, _fileAccessibility.getVisibilityOptionForFile)(file);

      var visibilityText = _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerCore.fileVisibility." + visibilityOption + ".text"
      });

      var href = (0, _file.getFileDetailsFileManagerAppLink)(file, {
        source: _Constants.PICKER_CHANGE_VISIBILITY_SOURCE
      });
      return _react.default.createElement(_Small.default, {
        use: "help",
        className: "display-block m-top-2"
      }, _react.default.createElement(_UIHelpIcon.default, {
        title: _react.default.createElement(_FormattedMessage.default, {
          message: "FileManagerCore.fileVisibility." + visibilityOption + ".help"
        })
      }, _react.default.createElement(_FormattedReactMessage.default, {
        message: "FileManagerLib.fileDetail.visibility",
        options: {
          visibilityText: visibilityText
        }
      })), _react.default.createElement(_UILink.default, {
        className: "m-left-2",
        external: true,
        href: href
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerLib.fileDetail.visibilityChangeLink"
      })));
    }
  }, {
    key: "renderActions",
    value: function renderActions(file) {
      var _this$props7 = this.props,
          onDelete = _this$props7.onDelete,
          parentFolder = _this$props7.parentFolder,
          folderCount = _this$props7.folderCount,
          isReadOnly = _this$props7.isReadOnly,
          isSingleFileFetched = _this$props7.isSingleFileFetched,
          withPanelNavigator = _this$props7.withPanelNavigator;

      if (!isSingleFileFetched) {
        return _react.default.createElement("div", {
          className: "m-bottom-4"
        }, _react.default.createElement(_UILoadingSpinner.default, null));
      }

      return _react.default.createElement(_react.Fragment, null, withPanelNavigator && (0, _file.getShouldRenderFileUrl)({
        file: file
      }) && this.renderFileUrl(file), _react.default.createElement("div", {
        className: "m-bottom-4"
      }, folderCount > 0 && _react.default.createElement(_MoveButton.default, {
        size: "extra-small",
        folder: parentFolder,
        onMove: this.handleMove,
        isReadOnly: isReadOnly
      }), file.get('type') === _Constants.FileTypes.IMG && (0, _image.isEditableImage)(file) && this.renderEditButtons(), _react.default.createElement(_DeleteFileContainer.default, {
        file: file,
        onDelete: onDelete,
        isReadOnly: isReadOnly
      })), _react.default.createElement("div", null, !withPanelNavigator && this.renderInsertButton(file), !withPanelNavigator && (0, _file.getShouldRenderFileUrl)({
        file: file
      }) && this.renderFileUrl(file)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props8 = this.props,
          tile = _this$props8.tile,
          isCanvaFile = _this$props8.isCanvaFile,
          isReadOnly = _this$props8.isReadOnly,
          isBrowsingFolder = _this$props8.isBrowsingFolder,
          isSingleFileFetched = _this$props8.isSingleFileFetched,
          withPanelNavigator = _this$props8.withPanelNavigator;
      var file = tile.get('file');
      var dimensions = this.getDimensions();
      var showBreadcrumbs = withPanelNavigator || !isBrowsingFolder;
      return _react.default.createElement("div", {
        ref: function ref(c) {
          _this3.wrapper = c;
        },
        className: (0, _classnames.default)('file-detail', {
          'with-panel-navigator': withPanelNavigator
        })
      }, !withPanelNavigator && this.renderArrow(tile), _react.default.createElement("div", {
        className: "file-detail__wrapper"
      }, !withPanelNavigator && _react.default.createElement(_UICloseButton.default, {
        className: "file-detail__close-button",
        size: "medium",
        onClick: this.handleCloseButtonClick
      }), showBreadcrumbs && _react.default.createElement(_FilePathBreadcrumbs.default, {
        object: file,
        fullPath: file.get('full_path')
      }), _react.default.createElement(_Filename.default, {
        file: file,
        onUpdate: this.handleRename,
        isReadOnly: isReadOnly
      }), this.renderFile(file), _react.default.createElement(_UIList.default, {
        className: (0, _classnames.default)('file-detail__meta', withPanelNavigator ? 'm-bottom-2' : 'm-bottom-4')
      }, dimensions && _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerLib.fileDetail.dimensions",
        options: {
          dimensions: dimensions
        }
      })), _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerLib.fileDetail.type",
        options: {
          type: file.get('extension')
        }
      })), _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerLib.fileDetail.size",
        options: {
          size: this.getSize()
        }
      })), isCanvaFile && _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerLib.fileDetail.source",
        options: {
          source: 'Canva'
        }
      })), (0, _getIsFileOptimizableImage.default)(file) && this.renderImageOptimizationControl(), isSingleFileFetched && this.renderVisibility(file)), this.renderActions(file)));
    }
  }]);
  return FileDetail;
}(_react.Component);

FileDetail.propTypes = {
  tile: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  isCanvaFile: _propTypes.default.bool,
  folderCount: _propTypes.default.number.isRequired,
  parentFolder: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  isBrowsingFolder: _propTypes.default.bool.isRequired,
  onAcquireFromCanva: _propTypes.default.func.isRequired,
  onInsert: _propTypes.default.func.isRequired,
  onClose: _propTypes.default.func.isRequired,
  onDelete: _propTypes.default.func.isRequired,
  onMove: _propTypes.default.func.isRequired,
  onRename: _propTypes.default.func.isRequired,
  onUpdateHeight: _propTypes.default.func,
  trackInteraction: _propTypes.default.func.isRequired,
  isReadOnly: _propTypes.default.bool.isRequired,
  isHostAppContextPrivate: _propTypes.default.bool.isRequired,
  uploadedFileAccess: _propTypes.default.oneOf(Object.keys(_FileAccess.DrawerFileAccess)),
  isSingleFileFetched: _propTypes.default.bool.isRequired,
  withPanelNavigator: _propTypes.default.bool.isRequired
};
FileDetail.defaultProps = {
  withPanelNavigator: false
};
var _default = FileDetail;
exports.default = _default;
module.exports = exports.default;